/**
 * Layout and Global UI Component
 * Handles side panels, theme switching, and global overlays.
 */

export function LayoutComponent() {
    return {
        openPanel: null,
        isDark: document.documentElement.classList.contains('dark'),
        sidebarCollapsed: localStorage.getItem('sidebar-collapsed') === 'true',

        init() {
            // Apply stored sidebar state on load
        },

        setTheme(mode) {
            this.isDark = mode === 'dark';
            document.documentElement.classList.toggle('dark', this.isDark);
            localStorage.setItem('theme', mode);

            // Dispatch event for other components (like Charts) to respond
            window.dispatchEvent(
                new CustomEvent('theme-changed', {
                    detail: { theme: mode },
                })
            );
        },

        togglePanel(panelName) {
            this.openPanel = this.openPanel === panelName ? null : panelName;
        },

        closePanels() {
            this.openPanel = null;
        },

        toggleSidebar() {
            this.sidebarCollapsed = !this.sidebarCollapsed;
            localStorage.setItem('sidebar-collapsed', this.sidebarCollapsed);
        },
    };
}
